import React from "react";
import { createPortal } from "react-dom";
import Modal from "../../../Components/Modal";


const BetalingModal = ({ visible, onClose, betaling }) => {
  if (!betaling) return null;

  const {
    id,
    status,
    amount,
    method,
    paidAt,
    details,
    description,
    _links,
  } = betaling;

  return createPortal(
    <Modal visible={visible} onClose={onClose} height={400} width={520}>
      <div className="p-3">
        <h5 className="mb-3">💳 Betalingsdetails</h5>
        <div className="mb-2">
          <strong>Betaling ID:</strong>
          <div className="text-muted small">{id}</div>
        </div>
        <div className="mb-2">
          <strong>Status:</strong> <span className={`badge bg-${status === 'paid' ? 'success' : 'secondary'}`}>{status}</span>
        </div>
        <div className="mb-2">
          <strong>Bedrag:</strong> € {parseFloat(amount?.value).toFixed(2)}
        </div>
        <div className="mb-2">
          <strong>Methode:</strong> {method}
        </div>
        <div className="mb-2">
          <strong>Betaald op:</strong> {new Date(paidAt).toLocaleString()}
        </div>
        <div className="mb-2">
          <strong>Omschrijving:</strong>
          <div className="text-muted small">{description}</div>
        </div>

        {details && (
          <div className="mb-2">
            <strong>Naam betaler:</strong> {details.consumerName}
            <br />
            <strong>Rekening:</strong> {details.consumerAccount}
          </div>
        )}

        {_links?.dashboard?.href && (
          <div className="mt-4 text-end">
            <a
              href={_links.dashboard.href}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-primary"
            >
              Bekijk in Mollie
            </a>
          </div>
        )}
      </div>
    </Modal>,
    document.body
  );
};

export default BetalingModal;